import Fuse from 'fuse.js'
import { Video } from './common'

interface SearchParams {
  searchQuery?: string
  videos: Video[]
}

export const search = ({ searchQuery, videos }: SearchParams) => {
  const fuse = new Fuse(videos, {
    keys: ['title', 'tags'],
    threshold: 0.5,
  })

  const result = searchQuery ? fuse.search(searchQuery) : null
  return result ? result.map(({ item }) => item) : videos
}
